import { Space, Typography } from 'antd';
import { WarningFilled } from '@ant-design/icons';
import { H3 } from 'components/new-ui/base/typography/styles';

const TransportDetailsDiscrepenciesWarning = () => {
    return (
        <div
            style={{
                padding: '12px 16px',
                background: 'var(--orange-1)',
                border: '1px solid var(--orange-3)',
                lineHeight: '22px',
                marginTop: 12,
                marginBottom: 16,
                borderRadius: 6,
            }}
        >
            <Space size={8}>
                <WarningFilled style={{ color: 'var(--orange-6)' }} />
                <H3>Transport details do not match the manifest</H3>
            </Space>

            <Typography style={{ marginTop: 4 }}>
                This declaration's transport details differ from the rest of the manifest. Review and amend to bring it
                in line.
            </Typography>
        </div>
    );
};

export default TransportDetailsDiscrepenciesWarning;
